import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (err) {
        if (err.response?.status === 404) { setStatus("error"); return; }
      }
      if (tries++ < 12) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-cream grid place-items-center p-6 font-body">
      <div className="bg-cream-card border border-cream-deep rounded-3xl p-10 max-w-md text-center" data-testid="payment-result">
        {status === "checking" && <><Loader2 className="h-14 w-14 text-brand mx-auto animate-spin" /><h1 className="text-2xl font-bold text-brand mt-5">Confirming your payment…</h1></>}
        {status === "paid" && <><CheckCircle2 className="h-16 w-16 text-rag-green mx-auto" /><h1 className="text-2xl font-bold text-brand mt-5">Payment successful</h1><p className="text-muted-foreground mt-2">Your subscription is active. Welcome aboard!</p><Button data-testid="payment-continue" onClick={() => nav("/app")} className="mt-6 rounded-full bg-brand hover:bg-brand-hover text-white h-11 px-8">Go to dashboard</Button></>}
        {(status === "error" || status === "timeout") && <><XCircle className="h-16 w-16 text-rag-red mx-auto" /><h1 className="text-2xl font-bold text-brand mt-5">{status === "timeout" ? "Still processing" : "Something went wrong"}</h1><p className="text-muted-foreground mt-2">{status === "timeout" ? "Your payment is taking longer than expected. Check your dashboard shortly." : "We couldn't confirm the payment."}</p><Button onClick={() => nav("/app")} className="mt-6 rounded-full bg-brand text-white h-11 px-8">Go to dashboard</Button></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-cream grid place-items-center p-6 font-body">
      <div className="bg-cream-card border border-cream-deep rounded-3xl p-10 max-w-md text-center">
        <XCircle className="h-16 w-16 text-rag-amber mx-auto" />
        <h1 className="text-2xl font-bold text-brand mt-5">Payment cancelled</h1>
        <p className="text-muted-foreground mt-2">No charge was made. You can try again anytime.</p>
        <Button onClick={() => nav("/app")} className="mt-6 rounded-full bg-brand text-white h-11 px-8">Back to dashboard</Button>
      </div>
    </div>
  );
}
